import {environment} from '../environments/evironment';
import common from "../helpers/common";
import {v4 as uuidv4} from 'uuid';

export default {
    /**
     * Get the account settings using the primary URL
     * @param accountKey
     * @param parentLocation
     * @returns {XMLHttpRequest}
     */
    getAccountConfig(accountKey, parentLocation = null) {
        parentLocation = parentLocation === null ? document.location.origin : parentLocation;
        const browserInfo = common.browserDetection();
        const objLog = {
            channel: 'digitalGate',
            evento: 'Get settings',
            status: 'success',
            data: [browserInfo]
        };
        const url = `${environment.API_DG_URL}AccountSettingsAllianz.json?nocache=`+Date.now();
        const xhr = new XMLHttpRequest();

        this.saveEventLog(objLog, accountKey);

        xhr.open('GET', url, true);
        xhr.send();

        return xhr;
    },

    /**
     * Get the account settings using the secondary URL
     * @param accountKey
     * @param parentLocation
     * @returns {XMLHttpRequest}
     */
    getAccountConfigSecondary(accountKey, parentLocation = null) {
        parentLocation = parentLocation === null ? document.location.origin : parentLocation;
        const browserInfo = common.browserDetection();
        const objLog = {
            channel: 'digitalGate',
            evento: 'Get settings',
            status: 'success',
            data: [browserInfo]
        };
        const url = `${environment.API_SECONDARY_URL}digitalGateApi/accountwithchannels?token=${accountKey}&url=${parentLocation}`;
        const xhr = new XMLHttpRequest();

        this.saveEventLog(objLog, accountKey);

        xhr.open('GET', url, true);
        xhr.setRequestHeader('Ocp-Apim-Subscription-Key', environment.API_DG_KEY);
        xhr.send();

        return xhr;
    },

    /**
     * Save the interaction with the DG
     * @param eventLog
     * @param accountKey
     * @param href
     */
    saveEventLog(eventLog, accountKey, href = null) {
        if (eventLog.channel == 'floating btn' && eventLog.evento == 'Open digitalgate') {
            this.setInteraction(eventLog);
        } else {
            if (!localStorage.getItem('dgInteraction')) {
                this.setInteraction(eventLog);
            } else {
                const lsInteraction = JSON.parse(localStorage.getItem('dgInteraction'));
                if (lsInteraction.channel != 'floating btn') {
                    this.setInteraction(eventLog);
                }
            }
        }

        const interactionId = JSON.parse(localStorage.getItem('dgInteraction'));
        const objLog = {
            interactionId: interactionId.iid,
            token: accountKey,
            canal: eventLog.channel,
            evento: eventLog.evento,
            status: eventLog.status,
            data: eventLog.data ? eventLog.data : '',
            url: btoa(href === null ? document.location.href : href)
        };
        const url = `${environment.API_SAVE_URL}?code=${environment.CODE_SAVELOG}`;
        const data = new FormData();
        const xhr = new XMLHttpRequest();

        data.append('data', JSON.stringify(objLog));

        xhr.open('POST', url, true);
        xhr.setRequestHeader('Cache-Control', 'no-cache');
        xhr.send(data);
    },

    /**
     * Saves interaction with the DG at the local level
     * @param eventLog
     */
    setInteraction(eventLog) {
        const dgInteraction = {
            channel: eventLog.channel,
            iid: uuidv4()
        };
        localStorage.setItem('dgInteraction', JSON.stringify(dgInteraction));
    },
}
